import { useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Globe, MessageCircle, Smartphone } from "lucide-react";
import { api } from "@/lib/api";

const QrTile = ({ icon: Icon, title, hint, value, testid, disabled }) => (
  <div className="ds-card flex items-center gap-4 p-4" data-testid={testid}>
    <div className={`shrink-0 rounded-xl bg-white p-2 ${disabled ? "opacity-30" : ""}`}>
      <QRCodeCanvas value={value || "https://digitalshop.gn"} size={92} level="M" includeMargin={false} />
    </div>
    <div className="min-w-0">
      <p className="flex items-center gap-1.5 font-display text-sm font-bold text-slate-900">
        <Icon className="h-4 w-4 text-brand" /> {title}
      </p>
      <p className="mt-1 text-xs text-slate-500">{hint}</p>
      {disabled && <p className="mt-1 text-[11px] font-semibold text-gold-dark">Lien à configurer par l'administrateur</p>}
    </div>
  </div>
);

export const QrSection = () => {
  const [links, setLinks] = useState(null);

  useEffect(() => {
    api.get("/app-links").then((r) => setLinks(r.data)).catch(() => setLinks({}));
  }, []);

  if (!links) return null;

  const siteUrl = links.site_url || window.location.origin;
  const waNumber = String(links.whatsapp_number || "").replace(/[^0-9]/g, "");
  const waUrl = waNumber
    ? `https://wa.me/${waNumber}?text=${encodeURIComponent(links.whatsapp_message || "Bonjour EMPIRE-SHOP")}`
    : "";

  return (
    <section className="mx-auto max-w-7xl px-4 py-6" data-testid="qr-section">
      <h2 className="font-display text-xl font-bold text-slate-900 sm:text-2xl">Accédez à EMPIRE-SHOP partout</h2>
      <p className="text-sm text-slate-500">
        Scannez avec l'appareil photo de votre téléphone — utile aussi pour vos affiches et votre boutique.
      </p>
      <div className="mt-4 grid gap-3 md:grid-cols-3">
        <QrTile
          icon={Globe}
          title="Ouvrir la boutique"
          hint="Scannez puis « Ajouter à l'écran d'accueil » pour utiliser EMPIRE-SHOP comme une application."
          value={siteUrl}
          testid="qr-site"
        />
        <QrTile
          icon={MessageCircle}
          title="Commander par WhatsApp"
          hint={waNumber ? `Discutez directement avec notre équipe (+${waNumber})` : "Numéro WhatsApp non encore configuré."}
          value={waUrl || siteUrl}
          disabled={!waNumber}
          testid="qr-whatsapp"
        />
        <QrTile
          icon={Smartphone}
          title={links.store_label || "Application mobile"}
          hint={links.store_url ? "Téléchargez l'application EMPIRE-SHOP." : "Le lien Play Store / App Store sera ajouté dès publication."}
          value={links.store_url || siteUrl}
          disabled={!links.store_url}
          testid="qr-store"
        />
      </div>
    </section>
  );
};
